<template id="text-excerpt">
  <div>
    <span v-if="needExcerpt()" v-on:click="toggleExcerpt">
      <span v-html="excerptContent" v-if="excerpted"></span>
      <span v-html="contentHTML" v-else></span>
    </span>
    <span v-html="contentHTML" v-else>
    </span>

    <span class="btn btn-default btn-xs" v-if="needExcerpt() && excerpted" v-on:click="toggleExcerpt">更多</span>
  </div>
</template>

<script>
export default {
  props: ['content'],
  data() {
    return {
      excerpted: true
    };
  },
  computed:
    {
      contentHTML() {
        return this.content.replace(/(\r\n|\n\r|\r|\n)/g,"<br>");
      },
      excerptContent() {
        return this.content.slice(0, 100) + "...";
      }
    },
  methods:
    {
      needExcerpt() {
        return this.content.length >= 110;
      },
      toggleExcerpt() {
        return this.excerpted = !this.excerpted;
    }
  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/text_excerpt.vue